<template>
    <router-view/>
</template>
<script>
    export default {
        name: "BaseRouterView"
    }
</script>
